import { initializePartnerEventEmitter } from '@dixa/lib-integrations-partner-widgets';
import { commonPartnerTrackingEvents, githubPartnerTrackingEvents, jiraPartnerTrackingEvents, klaviyoPartnerTrackingEvents, linearPartnerTrackingEvents, shopifyPartnerTrackingEvents, } from './tracking';
/**
 * Here we initialize the event handling of the Partner Integration widgets. In
 * order to not use `analytics` directly in the widgets we emmit our own events
 * and create listeners to forward each to `analytics`. This way the partner
 * team is decoupled from the tracking implementation in agent-interface.
 */
export const initPartnerIntegrationsEvents = () => {
    var _a;
    initializePartnerEventEmitter();
    if ((_a = window === null || window === void 0 ? void 0 : window._partner) === null || _a === void 0 ? void 0 : _a.events) {
        const partnerEvents = window._partner.events;
        commonPartnerTrackingEvents({ partnerEvents });
        shopifyPartnerTrackingEvents({ partnerEvents });
        jiraPartnerTrackingEvents({ partnerEvents });
        linearPartnerTrackingEvents({ partnerEvents });
        githubPartnerTrackingEvents({ partnerEvents });
        klaviyoPartnerTrackingEvents({ partnerEvents });
    }
};
